/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_StatusInputs */

const en_cmd_status = /** @type {(inputs: Cmd_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change status`)
};

const de_cmd_status = /** @type {(inputs: Cmd_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status ändern`)
};

/**
* | output |
* | --- |
* | "Change status" |
*
* @param {Cmd_StatusInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_status = /** @type {((inputs?: Cmd_StatusInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_StatusInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_status(inputs)
	return en_cmd_status(inputs)
});